// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"9fb9d7ff","188":"bffcf8f6","305":"3be20f38","427":"fb9d90d5","454":"e59fbe5d","662":"ce9ed677"}[chunkId] + ".chunk.js";
};